import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=38e3c5a0&scoped=true"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"
import style0 from "./theme.vue?vue&type=style&index=0&id=38e3c5a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3c5a0",
  null
  
)

export default component.exports